import illegalMail from './illegal-mail.riot';
import { ajaxPost } from '../ajax';
import { router } from '@riotjs/route';
import { illegalMailFailure, illegalMailSuccess, illegalMailRequest } from './illegal-mail.action';
import { connect } from '@/common/lib/riot-redux';

const mapDispatchToProps = (dispatch, props) => ({
  async onNotifyClick() {
    dispatch(illegalMailRequest());
    try {
      await ajaxPost('/notifyadmin', {
        method: 'notifyIllegalMail',
        key: props.illegalKey
      });
      router.push('result');
      dispatch(illegalMailSuccess());
    } catch (e) {
      dispatch(illegalMailFailure(e));
    }
  }
});

export default connect(illegalMail, null, mapDispatchToProps);